import styled from 'styled-components';
import { CommonDetails } from '../common-styles.styles';

export const FAQWrapper = styled(CommonDetails)`
  line-height: 1.5;
  strong {
    color: #000000;
  }
  a {
    color: #166bd3;
    cursor: pointer;
    outline: none;
    text-decoration: none;
  }
  a:hover {
    color: #f77521;
  }
`;

export const QnAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  padding-top: 10px;
  padding-bottom: 17px;
`;

export const QuestionWrapper = styled.div`
  color: #000000;
`;

export const AnswerWrapper = styled.div`
  color: #666666;
`;
